(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('FaqListController', FaqListController);

    /** @ngInject */
    function FaqListController($state, $stateParams, $timeout, FaqService, HelperService) {
        const vm = this;

        vm.onChangeCategory = () => {
            $state.go('app-master.default.faq', {
                faqCategory: vm.selectedCategory.Url,
                faqId: null
            });

            getFaqs();
        }

        vm.onSelectFaq = faq => {
            $state.go('app-master.default.faq', {
                faqCategory: vm.selectedCategory.Url,
                faqId: faq.Id
            });

            $timeout(() => {
                let element = $(`#faqCollapse${faq.Id}`);

                $([document.documentElement, document.body]).animate({
                    scrollTop: element.offset().top - ($('.header').outerHeight() + 40)
                }, 600);
            }, 250);
        }

        init();

        function getCategories() {
            HelperService.startLoading('.faq-holder');

            FaqService
                .getCategories()
                .then(success => {
                    vm.faqCategories = success;

                    let currentCategory = vm.faqCategories.find(x => (x.Url == $stateParams.faqCategory));

                    if (currentCategory) {
                        vm.selectedCategory = currentCategory;
                        getFaqs();
                    }

                    HelperService.stopLoading('.faq-holder');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getFaqById() {
            HelperService.startLoading('.faq-holder');

            vm.isLoading = true;
            vm.faqs = [];

            FaqService
                .getById($stateParams.faqId)
                .then(success => {
                    vm.faqs.push(success);

                    $timeout(() => {
                        let faq = $(`#faqCollapse${success.Id}`);

                        faq.collapse();

                        $([document.documentElement, document.body]).animate({
                            scrollTop: faq.offset().top - ($('.header').outerHeight() + 40)
                        }, 600);
                    }, 250);

                    vm.isLoading = false;
                    HelperService.stopLoading('.faq-holder');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getFaqs() {
            if ($stateParams.faqId) {
                getFaqById();
                return;
            }

            HelperService.startLoading('.faq-holder');

            vm.isLoading = true;

            FaqService
                .getAllByParameters({
                    Active: true,
                    PerPage: 9999,
                    Skip: 0,
                    CategoryId: vm.selectedCategory.Id
                })
                .then(success => {
                    vm.faqs = success.Faq;
                    vm.isLoading = false;
                    HelperService.stopLoading('.faq-holder');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function init() {
            vm.faqs = [];
            vm.isLoading = false;

            getCategories();
        }
    }
}());